import { getTravleList } from '@/axios/api'

const travleList = {
  state: {
    travleList: []
  },
  mutations: {
    SET_TRAVLELIST (state, travleList) {
      state.travleList = travleList
    }
  },
  actions: {
    TRAVLELIST ({ commit }, params) {
      getTravleList(params).then(res => {
        this.state.travleList = res.data.data
      })
    }
  }
}

export default travleList



// WEBPACK FOOTER //
// ./src/store/modules/getTravleList.js